import { on } from 'delegated-events'

const fn = {
  init: () => {
    on('click', '.add-to-calendar button', (e) => {
      const holder = e.target.closest('.add-to-calendar')

      holder.classList.toggle('is-open')
    })

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.add-to-calendar')) {
        document.querySelectorAll('.add-to-calendar').forEach((el) => {
          el.classList.remove('is-open')
        })
      }
    })
  },
}

export default {
  can: () => true,
  run: fn.init,
}
